import type { ScheduleRealignment } from './api.ts'

/**
 * What to tell whoever saved part of an account's clock -- its zone (#674) or
 * its ERP read window (#675) -- about the account's schedules. A move that
 * failed is an error even though the change was saved: until somebody presses
 * Atualizar, the nightly sweep still fires where it did.
 *
 * `saved` is the headline of the save itself, as the section says it.
 */
export function realignmentNotice(
  saved: string,
  schedules: ScheduleRealignment,
): {
  readonly tone: 'success' | 'error'
  readonly message: string
  readonly detail?: string
} {
  if (schedules === null) return { tone: 'success', message: saved }
  if ('error' in schedules) {
    return {
      tone: 'error',
      message: `${saved}, mas as rotinas da conta não foram atualizadas`,
      detail: `${schedules.error}. Use Atualizar em cada rotina desta conta, na tela Rotinas.`,
    }
  }
  const moved = schedules.realigned.length
  if (moved === 0) return { tone: 'success', message: saved }
  return {
    tone: 'success',
    message:
      moved === 1 ? `${saved}; 1 rotina atualizada` : `${saved}; ${moved} rotinas atualizadas`,
  }
}
